export default __webpack_public_path__ + "static/media/resources.487326a2.mp3";